import referenceDate from "../reference-date";

export default function isCurrentPeriod(
  date, // May be `null` for current date.
  item,
) {
  const reference = referenceDate(date);

  // Note, the following applies for the time part if these `DateTime`s are not `null` or `undefined`:
  // - `startDate` is always set to 00:00:00.000 (= first day)
  // - `endDate` is always set to 23:59:59.999 (= last day)
  // However:
  // - `frontendDisplayStartDate` is always set to 00:00:00.000 (= first visible day)
  // - `frontendDisplayEndDate` is *also* always set to 00:00:00.000! (= next day, or first invisible day)
  // => The season field `frontend_display_end_date` is used as the table's TYPO3 `endtime`.
  //    Its label is, for clarification, changed to "Invisible starting from (at midnight)".
  //    We do not want editors to have to select 23:59 in a date picker - that would be error prone.

  const current =
    new Date(item.startDate) <= reference &&
    new Date(item.endDate) >= reference;

  // Apply visibility if set. (Only set for seasons.)
  const visible =
    (!item.frontendDisplayStartDate || // `null` or `undefined`
      new Date(item.frontendDisplayStartDate) <= reference) &&
    (!item.frontendDisplayEndDate || // `null` or `undefined`
      new Date(item.frontendDisplayEndDate) >= reference);

  return current && visible;
}
